import { Button, ButtonColorVariant, ButtonVariant, Checkbox, IconVariants, Size } from "@next-platform/client-common-spicy-ui";
import { useTranslation } from "@next-platform/client-common-core";

import Trans from "@/components/Trans/Trans";
import { cn } from "@/utils";

import { Row } from "../customComponents";
import { ChatsMultiSelectButtonGroupProps } from "./types";

export function ChatsMultiSelectButtonGroup({
  isMultiSelectMode,
  selectedCount,
  totalCount,
  visibleCount,
  onToggleMultiSelect,
  onSelectAll,
  onCancel,
  onRemoveSelected,
}: ChatsMultiSelectButtonGroupProps) {
  const { t } = useTranslation();
  const allSelected = selectedCount > 0 && selectedCount === totalCount;
  const someSelected = selectedCount > 0 && selectedCount < totalCount;
  const isCheckboxDisabled = visibleCount === 0;

  if (isMultiSelectMode) {
    return (
      <Row className="items-center gap-sm flex-wrap">
        <Checkbox
          label={t("common:selectAll")}
          size={Size.MEDIUM}
          checked={allSelected}
          indeterminate={someSelected}
          icon={someSelected ? IconVariants.MINUS : IconVariants.CHECK}
          onChange={(e) => onSelectAll((e.target as HTMLInputElement).checked)}
          className={cn(someSelected && "!bg-blue-10 !border-blue-10")}
          classNames={{ icon: cn(someSelected && "text-white") }}
          disabled={isCheckboxDisabled}
        />
        <Button variant={ButtonVariant.OUTLINED} onClick={onCancel}>
          <Trans i18nKey="common:cancel" />
        </Button>
        <Button color={ButtonColorVariant.ERROR} iconStart={IconVariants.TRASH} onClick={onRemoveSelected} disabled={selectedCount === 0}>
          <Trans i18nKey="chats:page.common.button.removeSelected" />
        </Button>
      </Row>
    );
  }
  return (
    <Button onClick={onToggleMultiSelect}>
      <Trans i18nKey="chats:page.common.button.manage" />
    </Button>
  );
}
